import { render, staticRenderFns } from "./MultipleInput.vue?vue&type=template&id=51355841&scoped=true&"
import script from "./MultipleInput.vue?vue&type=script&lang=js&"
export * from "./MultipleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51355841",
  null
  
)

export default component.exports